function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "middle");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "2_Artikel_Kasse",
  transform: "translate(-415.000000, -884.000000)",
  fill: "#C3C3C3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Produktname_001",
  transform: "translate(330.000000, 105.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M85.5,779 C85.7761424,779 86,779.223858 86,779.5 L86,801 L105,801 C105.276142,801 105.5,801.223858 105.5,801.5 C105.5,801.776142 105.276142,802 105,802 L86,802 L86,823.5 C86,823.776142 85.7761424,824 85.5,824 C85.2238576,824 85,823.776142 85,823.5 L85,779.5 C85,779.223858 85.2238576,779 85.5,779 Z",
  id: "middle",
  transform: "translate(95.250000, 801.500000) scale(1, -1) translate(-95.250000, -801.500000) "
}))));

var SvgMiddle = function SvgMiddle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "45px",
    viewBox: "0 0 21 45",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMiddle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/middle.ac90d37f.svg";
export { ForwardRef as ReactComponent };